import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { MapPin, CheckCircle } from 'lucide-react';

const ServiceSelection = ({ services, selectedService, onSelect }) => {
  const groupedServices = {
    'Domestic Services (Exeter)': services.filter(s => ['domestic_epc', 'domestic_advice'].includes(s.id)),
    'Commercial Services (South West)': services.filter(s => ['commercial_warehouse', 'commercial_hotel_office', 'commercial_advice'].includes(s.id)),
    'Heat Load Calculations': services.filter(s => ['heat_load_remote', 'heat_load_onsite', 'heat_load_mcs_pack', 'heat_load_epc_bundle'].includes(s.id)),
    'Nationwide Digital Services': services.filter(s => ['sap_calculation', 'u_values', 'sbem', 'thermal_bridge', 'dynamic_thermal', 'retrofit'].includes(s.id)),
    'Floor Plans': services.filter(s => ['marketing_plans', 'leasehold_plans'].includes(s.id))
  };

  return (
    <div data-testid="service-selection-step">
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Select Your Service</h2>
      <p className="text-gray-600 mb-6">Choose the service you need</p>

      <div className="space-y-8">
        {Object.entries(groupedServices).map(([category, categoryServices]) => (
          categoryServices.length > 0 && (
            <div key={category}>
              <h3 className="text-lg font-semibold text-gray-800 mb-4">{category}</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {categoryServices.map(service => (
                  <Card
                    key={service.id}
                    onClick={() => onSelect(service.id, service.name)}
                    data-testid={`service-option-${service.id}`}
                    className={`cursor-pointer transition-all hover:shadow-lg ${
                      selectedService === service.id
                        ? 'ring-2 ring-green-600 shadow-md'
                        : 'hover:ring-1 hover:ring-gray-300'
                    }`}
                  >
                    <CardContent className="p-4">
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <h4 className="font-semibold text-gray-900 mb-1">{service.name}</h4>
                          <p className="text-sm text-gray-600 mb-2">
                            {service.price_on_request ? 'Price on Request' : `From £${service.base_price}`}
                          </p>
                          <div className="flex items-center gap-1 text-xs text-gray-500">
                            <MapPin className="w-3 h-3" />
                            <span>{service.requires_visit ? 'Site Visit Required' : 'Digital Service'}</span>
                          </div>
                        </div>
                        {selectedService === service.id && (
                          <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0" />
                        )}
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          )
        ))}
      </div>
    </div>
  );
};

export default ServiceSelection;